<template>
  <div class="dashboard-area">

    <div class="flex align-center justify-between size14" style="padding: 13px 0">
      <div class="flex align-center" style="height: 20px;">
        <i class="iconfont iconshangpinxiaoshoukanban"></i>
        <span class="size14 area-tit">商品销售看板</span>
        <transition name="filter">
          <div v-show="instantShow" class="flex align-center">
            <gj-help>
              <div>数据来源：亚马逊销售订单；</div>
              <div>使用说明：默认以所有站点当前市场时间进行计算，比实时看板数据延迟30分钟，除已取消订单不计入，其它所有状态参与计算，将导致销售相关字段数据虚高。</div>
            </gj-help>
            <i @click="query" class="iconfont iconshuaxin"></i>
            <span class="color666 size12">数据更新时间：{{updateTime}}</span>
          </div>
        </transition>
      </div>
      <gj-button type="iconfont" :iconfont="instantShow?'iconshouqi1':'iconsuofang'" size="14px" @click="setInstantShow"></gj-button>
    </div>


    <!--            折叠筐中dom变动，高度变化时，需在css中改变写死（也可用js取滚动高度）-->
    <transition name="panel">
      <div v-if="instantShow" style="overflow: hidden;will-change: height;">
        <div style="padding-bottom: 16px;">

          <el-tabs v-model="type">

            <app-filter-group
                advancedFiltering
                :screenOptons="screenOptons"
                @determine="filterQuery"
                @clear="filterQuery"
                @query="query"
                :reset="false"
                :isBr="false"
                ref="app-filter-group"
                style="margin-bottom: 12px"
            >

<!--              <gj-country-server-select-->
<!--                  v-model="countryMarket"-->
<!--                  :width="['110px','145px']">-->
<!--              </gj-country-server-select>-->

              <gj-brand-select
                  v-model="brandIds"
                  placeholder="品牌"
                  width="145px"
                  multiple
                  active
              ></gj-brand-select>
              <gj-category-select
                  v-model="categoryIds"
                  placeholder="品类"
                  width="160px"
                  multiple
                  active
              ></gj-category-select>
              <gj-operation-state-select
                  width="140px"
                  placeholder="运营状态"
                  v-model="operationStatus"
                  multiple
              >
              </gj-operation-state-select>
              <gj-charger-select
                  v-model="userIds"
                  collapse-tags
                  placeholder="全部负责人"
                  active
                  style="width: 150px">
              </gj-charger-select>

              <gj-input
                  v-model="keyword"
                  :placeholder="'请输入'+(type==='asin'?'子ASIN':type==='variationAsin'?'父ASIN':'MSKU')"
                  width="120px"
              ></gj-input>

              <!--            <gj-button @click="$gjQuery">查询</gj-button>-->

            </app-filter-group>


            <el-tab-pane label="子ASIN" name="asin" >
              <sale-instant-table
                  v-if="type==='asin'"
                  ref="asinTable"
                  :type="type"
                  typeSef="asin"
                  :columns="asinColumns"
                  :model="model"
              >
              </sale-instant-table>
            </el-tab-pane>
            <el-tab-pane label="父ASIN" name="variationAsin"  lazy>
              <sale-instant-table
                  v-if="type==='variationAsin'"
                  ref="variationAsinTable"
                  :type="type"
                  typeSef="variationAsin"
                  :columns="fuasinColumns"
                  :model="model"
              >
              </sale-instant-table>
            </el-tab-pane>
            <el-tab-pane label="MSKU" name="msku"  lazy>
              <sale-instant-table
                  ref="mskuTable"
                  v-if="type==='msku'"
                  :type="type"
                  typeSef="msku"
                  :columns="mskuColumns"
                  :model="model"
              >
              </sale-instant-table>
            </el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </transition>

    <transition name="mask">
      <app-mask v-if="instantShow" :top="'180px'"></app-mask>
    </transition>

  </div>
</template>

<script>
  import {queryMixin} from "@/minxins";
  import {mapGetters} from "vuex";
  import {convertToFullDate} from "@/utils/date.util";
  import AppMask from "@/views/modules/home/components/mask/mask";

  import SaleInstantTable from './components/sale-instant-table';
  import {SaleInstantTableColumns} from "@/views/modules/home/components/sale/enum";
  import Cookies from "js-cookie";
  import {AUTH_USER_ID} from "@/utils/auth";

  export default {
    name: "app-dashboard-sale-instant-table",
    components:{AppMask, SaleInstantTable},
    mixins: [queryMixin],
    created() {
      this.instantShow = Cookies.get(Cookies.get(AUTH_USER_ID)+'InstantShow')!=='0'
      this.sort.prop = 'todaySaleQuantity';

      this.asinColumns = this.asinColumns.concat(SaleInstantTableColumns)

      this.fuasinColumns = this._.cloneDeep(this.asinColumns)
      this.fuasinColumns[2].sortBy = 'variationAsin';
      this.fuasinColumns[2].header = '父ASIN/子ASIN';
      this.fuasinColumns[2].minWidth = '140px';

      this.mskuColumns = this._.cloneDeep(this.asinColumns)
      this.mskuColumns.splice(3,1)
      this.mskuColumns[2].sortBy = 'msku';
      this.mskuColumns[2].minWidth = '200px';
      this.mskuColumns[2].header = 'MSKU';
    },
    data() {
      return {
        SaleInstantTableColumns,
        instantShow:false,

        updateTime:convertToFullDate(new Date(),"yyyy-MM-dd hh:mm:ss"),

        // countryMarket: {},
        type: 'asin',
        brandIds:[],// 品牌
        categoryIds:[],// 品类
        operationStatus:[],// 运营状态
        userIds:[],// 负责人
        keyword:'',
        extendSearch:[],

        fuasinColumns:[],
        mskuColumns:[],
        asinColumns: [
          {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '140px', default: true, options: () => this.marketOption, disabled: true, 'tree-node': true, fixed: 'left',},
        ],
        // 高级筛选枚举
        screenOptons: [
          {text: 'ACOS', id: "acos",value: '',exp: 'gt', suffix: "%"},
          {text: 'ACOAS', id: "acoas",value: '',exp: 'gt', suffix: "%"},
          {text: 'ASOAS', id: "asoas",value: '',exp: 'gt', suffix: "%"},
          {text: 'ROAS', id: "roas",value: '',exp: 'gt', suffix: "%"},
          {text: '毛利率', id: "salesGrossProfitRate",value: '',exp: 'gt', suffix: "%"},
          {text: '广告花费', id: "adsSpend",value: '',exp: 'gt'},
          {text: '退款量', id: "refunds",value: '',exp: 'gt'}
        ],
      }
    },
    computed: {
      ...mapGetters(['marketOption', 'countryMarket']),
      model(){
        return {
          groupType: this.type,// 分组维度asin/父asin/msku
          countrys: this.countryMarket.countryIds,// 国家
          marketIds: this.countryMarket.marketIds,// 店铺
          brandIds: this.brandIds,// 品牌
          categoryIds: this.categoryIds,// 品类
          operationStatus: this.operationStatus,// 运营状态
          userIds: this.userIds,// 负责人
          extendSearch:this.extendSearch,
          keyword: this.keyword,// 输入框值
        }
      },
      // tabPaneHeight(){
      //   return {'height': this.clientWidth >= 1600?'544px':'444px'}
      // }
    },
    methods: {
      setInstantShow(){
        this.instantShow = !this.instantShow;
        Cookies.set(Cookies.get(AUTH_USER_ID)+'InstantShow', this.instantShow?1:0, {expires:14})
      },
      // 高级筛选查询
      filterQuery(extendSearch) {
        this.extendSearch = extendSearch;
      },
      query() {
        if(this.type === 'variationAsin'){
          this.$refs.variationAsinTable.$gjQuery()
        }else if(this.type === 'msku'){
          this.$refs.mskuTable.$gjQuery()
        }else{
          this.$refs.asinTable.$gjQuery()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "../common";
  /deep/ .el-tabs__header{
    margin-bottom: 12px;
  }
  /deep/ .el-tabs__item{
    height: 30px;
    line-height: 1;
  }
  .dashboard-area{
    padding-top: 0;
    padding-bottom: 0;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  /deep/ .bsr-content {
    display: flex;
    align-items: center;
  }
  /deep/ .analysis-icon {
    font-size: 21px;
    color: #1F6EEF;
    cursor: pointer;
    margin-right: 10px;
  }
  /deep/ .wrapper-loading{
    flex: 1;
    overflow: auto;
  }
  /deep/ .footer__pagination{
    border: none !important;
  }

  .filter-enter-active, .filter-leave-active {
    transition: opacity .3s;
  }

  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
  .panel-enter-active, .panel-leave-active {
    height:601px;
    transition: height .5s;
  }
  .panel-enter, .panel-leave-to /* .fade-leave-active below version 2.1.8 */ {
    height: 0;
  }

  .mask-enter-active, .mask-leave-active {
    transition: opacity .3s;
  }
  .mask-enter, .mask-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>

